import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IDocumentState {
  // fieldsChanged: Record<string, boolean>;
  tabsChanged: Record<string, boolean>;
}

const initialState: IDocumentState = {
  // fieldsChanged: {},
  tabsChanged: {},
};

export const changedFieldSlice = createSlice({
  name: "changedField",
  initialState,
  reducers: {
    // setFieldChanged: (
    //   state,
    //   action: PayloadAction<{ docId: string; hasChanged: boolean }>
    // ) => {
    //   const { docId, hasChanged } = action.payload;
    //   state.fieldsChanged[docId] = hasChanged;
    // },
    setTabEdited: (state, action: PayloadAction<{ tabId: string }>) => {
      const { tabId } = action.payload;

      state.tabsChanged[tabId] = true;
    },
    // resetTabEdited: (state, action: PayloadAction<{ docId: string }>) => {
    //   const { docId } = action.payload;
    //   state.fieldsChanged[docId] = false;
    // },
  },
});

export const { setTabEdited } =
  changedFieldSlice.actions;
// export const selectFieldChanged = (
//   state: { changedField: IDocumentState },
//   docId: string
// ) => state.changedField.fieldsChanged[docId] || false;
export const selectTabChanged = (
  state: { changedField: IDocumentState },
  tabId: string
) => state.changedField.tabsChanged[tabId] || false;

export const changedField = changedFieldSlice.reducer;
